import { getCredential } from './auth/credential';

export type IframeBridgePayload = {
  method: 'authorize' | 'linkOpen';
  callback?: string;
  data?: Record<string, any>;
};

/* istanbul ignore file */
window.addEventListener('message', (event: MessageEvent) => {
  const isClasstingSubDomain =
    event.origin.includes('classting.com') ||
    event.origin.includes('classting.net') ||
    event.origin.includes('classting.dev');

  if (isClasstingSubDomain) {
    try {
      const payload: IframeBridgePayload =
        typeof event.data === 'string' && JSON.parse(event.data);

      if (payload.method === 'authorize') {
        const credential = getCredential();

        const message = JSON.stringify({
          method: payload.callback,
          data: { token: credential?.accessToken },
        });

        const source = event.source as WindowProxy;
        source.postMessage(message, event.origin);
      }

      if (payload.method === 'linkOpen') {
        window.open(payload.data?.url);
      }
    } catch (error) {
      console.error(error);
    }
  }
});
